import { common } from './common';
import { navbar } from './navbar';
import { profile } from './profile';
import { dataSections } from './dataSections';
import { pages } from './pages';
import { popups } from './popups';
import { settings } from './settings';
import { legal } from './legal';

/**
 * English dictionary — the source of truth for every UI string in the app.
 * Split into one file per feature area (namespace) to keep files small.
 *
 * The other locales (pt-PT, pt-BR, es) mirror this structure and are typed
 * as `Messages`, so the TypeScript build fails if any key is missing there.
 */
export const en = {
  common,
  navbar,
  profile,
  dataSections,
  pages,
  popups,
  settings,
  legal,
};

/** Shape shared by every locale dictionary (derived from English). */
export type Messages = typeof en;
